"use strict";

require("core-js/modules/es6.array.index-of");

exports.__esModule = true;

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
} // https://github.com/acdlite/recompose/blob/master/src/packages/recompose/utils/omit.js


var omit = function omit(obj, keys) {
  var rest = _objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];

    if (key in rest) {
      delete rest[key];
    }
  }

  return rest;
};

exports["default"] = omit;